/**
 * Model Pricing Configuration
 *
 * CRITICAL: This is the single source of truth for model cost multipliers.
 * Both backend (Python) and frontend (TypeScript) load from this shared config.
 *
 * Keys are SSM model aliases (flash, gemini, opus), NOT raw model IDs.
 * The backend resolves aliases to provider:model_id via SSM at runtime.
 *
 * - Backend: Converts from JSON to Python dict
 * - Frontend: Imports this TypeScript module directly
 *
 * DO NOT modify pricing values without updating both JSON and TS files.
 */

export const MODEL_PRICING = {
  comment: "Model cost multipliers keyed by SSM alias - source of truth for both backend (Python) and frontend (TypeScript)",
  version: "2.0",
  multipliers: {
    "flash": 1.0,
    "gemini": 3.0,
    "opus": 5.0,
  } as const
} as const;

export type ModelAlias = keyof typeof MODEL_PRICING.multipliers;
export type ModelMultiplier = typeof MODEL_PRICING.multipliers[ModelAlias];
